export default "__VITE_ASSET__C5RB1YIe__"